import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Presentation from '../../containers/presentation';
import PresentationItem from '../../containers/presentation-item';
import PhotoInfo from '../../containers/photo-info';
import Cta from '../../containers/cta';

const PresentationBlock = props => <Presentation {...props} />;
PresentationBlock.displayName = 'Presentation';

export default withDynamicComponents({
  componentWhitelist: [
    Cta,
    PresentationItem,
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['cta', 'cta'],
    ['photoInfo', 'photoInfo'],
    ['presentationItem', 'presentationItem'],
  ],
})(PresentationBlock);



// WEBPACK FOOTER //
// ./src/blocks/presentation/index.jsx